"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/FastDelivery.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FastDelivery = function FastDelivery(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 246.27 122.6"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Fast Delivery"), _react2.default.createElement("g", {
    className: "fast-delivery",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "car",
    d: "M235.24 42.42h-31C201.37 31.81 192.6 0 185.11 0H118c-13.62 0-24.11 29.64-28 42.42h-7.24c-7.24 0-14.18 5.89-15.45 13.14l-6 34c-1.31 7.21 3.59 13.1 10.83 13.1h9.18c.09 11.32 8.52 19.93 20.44 19.93s23.38-8.61 27.46-19.93H170c.09 11.32 8.52 19.93 20.43 19.93s23.38-8.61 27.46-19.93h6.75c7.24 0 14.17-5.89 15.45-13.14l6-34c1.25-7.21-3.6-13.1-10.85-13.1zm-37.47 0h-45.52l6.44-36.5h25c2.98 2.15 9.39 19.96 14.09 36.5zM117 5.92h35.8l-6.44 36.5H96c5.06-16.24 14.14-36.5 21-36.5zm-14.2 110.75c-10.17 0-17-8.27-15.19-18.43s11.53-18.44 21.7-18.44 17 8.27 15.18 18.44-11.49 18.43-21.69 18.43zm88.65 0c-10.17 0-17-8.27-15.18-18.43S187.79 79.8 198 79.8s17 8.27 15.18 18.44-11.56 18.43-21.73 18.43zm42.69-27.14a9 9 0 0 1-8.48 7.21h-6.39C220.75 84 211.93 73.88 199 73.88S173.68 84 170.66 96.74h-40c1.47-12.74-7.35-22.86-20.28-22.86S85 84 82 96.74h-8.81a5.89 5.89 0 0 1-5.94-7.21l6-34a9 9 0 0 1 8.48-7.21H234.2a5.89 5.89 0 0 1 5.94 7.21z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "speed",
    d: "M49.84 102.49H18.19a2.42 2.42 0 0 1-2.44-3 3.7 3.7 0 0 1 3.48-3h31.65a2.42 2.42 0 0 1 2.44 3 3.7 3.7 0 0 1-3.48 3z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    "data-name": "speed",
    d: "M52.48 87.48h-50a2.42 2.42 0 0 1-2.44-3H0a3.7 3.7 0 0 1 3.48-3h50a2.42 2.42 0 0 1 2.44 3 3.7 3.7 0 0 1-3.44 3z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "speed-3",
    "data-name": "speed",
    d: "M55.13 72.47h-25a2.42 2.42 0 0 1-2.44-3 3.7 3.7 0 0 1 3.48-3h25a2.42 2.42 0 0 1 2.44 3 3.7 3.7 0 0 1-3.48 3z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19
    },
    __self: undefined
  })));
};
exports.default = FastDelivery;